import { render, staticRenderFns } from "./PurchaseOrderTotalModifiersForm.vue?vue&type=template&id=a10e0e68&scoped=true&"
import script from "./PurchaseOrderTotalModifiersForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderTotalModifiersForm.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderTotalModifiersForm.vue?vue&type=style&index=0&id=a10e0e68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10e0e68",
  null
  
)

export default component.exports